import { getInterventionCompleteIndex, getPhases } from 'pages/WellGuardian/WIR/utils';
import { Phase, WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR, WIRPhaseTypes } from 'types/wellGuardian';

export const getActivePhaseFromWirState = (wir: WIR, country: string) => {
  let activePhaseKey: Phase;
  if (wir.state === WIRPhaseTypes.INTERVENTION_COMPLETE) {
    return getInterventionCompleteIndex(wir, country);
  } else {
    activePhaseKey = WIRCreateJourneyStepsKeys[wir.state as keyof typeof WIRCreateJourneyStepsKeys];
  }

  return getPhases(wir, country).findIndex(item => item === activePhaseKey);
};
